import { VerlaufButton, VerlaufKomplett } from "./LinienführungAnlegenCss";

export default function AuswahlRückrichtungAusVorherigen({ previousVerlaeufe, previousRueck, rrCollection, setRrCollection }) {

    function handleVorherigeChange(e) {
        e.preventDefault();

        setRrCollection({
            ...rrCollection,
            rrAnalog: false,
            neueStrecke: false,
            bisherigeStrNutzen: !rrCollection.bisherigeStrNutzen,
            rrHalte: {},
            rrVerlauf: [],
            rrStreckenId: undefined,
            mirrored: undefined
        });
    }

    function chooseRadio(e, verlaufId) {
        handleAuswahlRadios(parseInt(e.target.value), verlaufId);
    }

    function handleAuswahlRadios(radioValue, verlaufId) {
        let specificVerlauf = previousVerlaeufe.filter(v => v.id === verlaufId);
        let verlauf = specificVerlauf[0].ext_verlauf_rr;
        verlauf.forEach(station => station["verlauf"] = specificVerlauf[0].verlauf_rr.includes(station.id_bhf))

        let halte = {};
        specificVerlauf[0].ext_verlauf_rr.forEach(station => {
            halte[station.pos] = specificVerlauf[0].halt_rr.includes(station.pos)
        });

        setRrCollection({
            ...rrCollection,
            rrStreckenId: radioValue,
            rrVerlauf: verlauf,
            rrHalte: halte,
            mirrored: specificVerlauf[0].mirrored_rr
        });
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    const updateVerlauf = (e) => {
        e.preventDefault();
        handleVerlaufChange(e.target.id);
    }

    function handleVerlaufChange(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        let currentState = completeStation.verlauf;
        completeStation.verlauf = !currentState;
        if (!currentState) {
            // nur wenn verlauf auf ja, dann halt auch
            handleHalteChange(bhfPos, true);
        }
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    function updateHalte(e) {
        handleHalteChange(e.target.value, e.target.checked);
    }

    function handleHalteChange(bhfPos, newState) {
        let currentHalte = rrCollection.rrHalte;
        currentHalte[bhfPos] = newState;
        if (!newState) {
            // wenn auf nein, dann auch verlauf nein
            setVerlaufFalse(bhfPos);
        }
        setRrCollection({
            ...rrCollection,
            rrHalte: currentHalte
        });
    }

    function setVerlaufFalse(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        completeStation.verlauf = false;
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    return (
        <div>
            <button className="ausklappsie" onClick={handleVorherigeChange}>
                <label>
                    {rrCollection.bisherigeStrNutzen ? <span>&#8722; </span> : <span>&#43; </span>} bisherige Rückrichtungen dieser Linie
                </label>
            </button>
            {rrCollection.bisherigeStrNutzen && <div className="ausklappsie-klappe">
                {previousRueck.map((verlauf, index) =>
                    <section key={verlauf.id}>
                        <fieldset onChange={(e) => { chooseRadio(e, verlauf.id) }}>
                            <label>
                                <input type="radio" value={verlauf.id_strecke} name="vorherige" />
                                Vorgänger: {index + 1} {verlauf.id_strecke} {verlauf.verlauf}
                            </label>
                        </fieldset>
                        <section style={{ marginLeft: "2em" }}>
                            <p style={{ fontSize: 'small' }}>{verlauf.gueltig_von} - {verlauf.gueltig_bis}</p>
                            {rrCollection.rrStreckenId === verlauf.id_strecke
                                ? <div>
                                    <VerlaufKomplett>
                                        <thead>
                                            <tr>
                                                <th>in Verlaufsbeschreibung</th>
                                                <th>Halt</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderingVerlauf(verlauf.ext_verlauf, verlauf.mirrored).map(bhf =>
                                                <tr key={bhf.pos}>
                                                    <td>
                                                        {/* verlauf */}
                                                        <VerlaufButton id={bhf.pos} value={bhf.pos} onClick={(e) => updateVerlauf(e)}
                                                            className={rrCollection.rrVerlauf.filter(station => station.pos === bhf.pos)[0].verlauf ? "active" : "inactive"}>
                                                            <span id={bhf.pos}>{bhf.pos}: </span>{bhf.bhf}</VerlaufButton>
                                                    </td>{/* halte */}
                                                    <td>
                                                        <input type="checkbox" value={bhf.pos} onChange={(e) => updateHalte(e)}
                                                            // disabled={!rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhf.pos))[0].verlauf}
                                                            checked={rrCollection.rrHalte[bhf.pos]} />
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </VerlaufKomplett>
                                </div>
                                : <p style={{ fontSize: 'small' }}>{orderingVerlauf(verlauf.ext_verlauf, verlauf.mirrored).map(bhf => `- ${bhf.pos}: ${bhf.bhf} -`)}</p>
                            }
                        </section>
                    </section>)}
            </div>}
        </div>
    )
}
